module.exports = __webpack_public_path__ + "img/lightingyee.76ea983f.png";